import { render, staticRenderFns } from "./artifact.vue?vue&type=template&id=cccfa616&scoped=true"
import script from "./artifact.vue?vue&type=script&lang=js"
export * from "./artifact.vue?vue&type=script&lang=js"
import style0 from "./artifact.vue?vue&type=style&index=0&id=cccfa616&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccfa616",
  null
  
)

export default component.exports